<template>
  <div
    v-if="toast.show"
    :class="[
      'fixed bottom-10 left-1/2 -translate-x-1/2 z-[110] px-8 py-4 rounded-2xl font-bold text-sm shadow-2xl animate-fadeIn flex items-center gap-3',
      toast.type === 'error' ? 'bg-red-600 text-white' : 'bg-gray-900 dark:bg-gray-700 text-white'
    ]"
  >
    <Icon v-if="toast.type === 'error'" icon="mdi:close-circle" class="w-5 h-5" />
    <Icon v-else icon="mdi:check-circle" class="w-5 h-5 text-green-400" />
    <span>{{ displayMessage }}</span>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import { Icon } from '@iconify/vue'
import { useI18n } from 'vue-i18n'
import { useToast } from '@/composables/useToast'

const { t } = useI18n()
const { toast } = useToast()

const displayMessage = computed(() => {
  if (toast.value.messageKey) {
    const translated = t(toast.value.messageKey)
    if (translated !== toast.value.messageKey) return translated
  }
  return toast.value.message
})
</script>
